import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { trackAction } from '@ctct/distui-helpers';
import { Button, Upsell, StatusTag } from '@ctct/ui-react';

import { cancelReasonIdToString } from './OfferCoaching';
import { BillingSvc } from '../api';
import image from '../assets/test.webp';
import { useCancelFlowContext } from '../CancelFlowContext';
import { useGetActivePromotions, useGetActivePromotionsV2, useGetCancelOfferValues } from '../hooks';
import './OfferPromo.scss';

const OfferPromo = ({ offerCount }) => {
  const [cancelFlowContext, cancelFlowReducer] = useCancelFlowContext();
  const [promoBodyText, setPromoBodyText] = useState('');
  const { isPromoApplied, cancelSuccessCallback, cancelReason } = cancelFlowContext;

  const { t } = useTranslation();
  const {
    content: { promoHeaderText, promoButtonText, promoCode, username },
  } = offerCount === 1 ? useGetActivePromotions() : useGetActivePromotionsV2();

  const cancelOfferValues = useGetCancelOfferValues();

  useEffect(() => {
    let promoBodyTextLocal = '';

    if (offerCount === 1) {
      promoBodyTextLocal = cancelOfferValues.CANCEL_OTHER_OFFER1_BODY;
    } else {
      const reasonCode = cancelReasonIdToString(cancelReason);

      if (reasonCode) {
        promoBodyTextLocal = cancelOfferValues[`CANCEL_${reasonCode}_OFFER2_BODY`];
      }
    }

    setPromoBodyText(promoBodyTextLocal);
  }, [offerCount, cancelReason]);

  // TODO: Look into moving this code into a separate hook (like useApplyPromotion)
  // since it's doing API work it *should* be in a hook, but you'll probably
  // need to use useCallback or something because it needs to trigger on a click
  const applyPromotion = () => {
    if (!isPromoApplied && promoCode && username) {
      const { setPromotion } = BillingSvc;

      setPromotion({ promoCode, username })
        .then(() => {
          trackAction({ action: 'cancel step 3>stay and receive promo button' });
          cancelFlowReducer({
            type: 'setPromoApplied',
            value: true,
          });
          // do we need to pass back a value for "promo applied"?
          cancelSuccessCallback();
          cancelFlowReducer({ type: 'close' });
        })
        .catch((error) => {
          cancelFlowReducer({
            type: 'setPromoApplied',
            value: false,
          });

          // TODO: refactor this into destructure syntax
          const data = error?.response?.data;

          cancelFlowReducer({
            type: 'setPromoError',
            value: Object.values(data || {}),
          });
        });
    }
  };

  return (
    <Upsell
      id="promo-offer"
      image={{ url: image }}
      imageSize="medium"
      overline={<StatusTag text={t('cancel-flow.steps.offer-promo.overline')} kind="warning" />}
      heading={promoHeaderText}
      subHeading={<span data-qe-id="subheading-cancel-offer">{promoBodyText}</span>}
      actions={
        <Button
          text={promoButtonText}
          data-qe-id="cancel-flow-select-promo"
          kind="primary"
          size="large"
          onClick={() => {
            applyPromotion();
          }}
        />
      }
      backgroundColor="orange"
      ringsPosition="leftCenter"
      ringsColor="orange"
    />
  );
};

OfferPromo.propTypes = {
  offerCount: PropTypes.number.isRequired,
};
export default OfferPromo;
